import {
  contenuCtaVideoMock,
  encartMiseEnAvantMock,
  galerie2it4iMock,
  heroModeleMock,
  pushFaqMock,
  sliderImplantationsMock,
  sliderVideoMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  heroModeleMock,
  sliderVideoMock(),
  sliderImplantationsMock,
  galerie2it4iMock,
  encartMiseEnAvantMock,
  contenuCtaVideoMock(),
  pushFaqMock,
];

export const detailsCusineMock: SlugPage = {
  ...pageBase({
    title: 'Détails Cuisine',
    type: 'details-cuisine',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
